import { type KeenSliderInstance } from 'keen-slider';
import { useKeenSlider } from 'keen-slider/react';
import { type RollBannerItem, RollingBannerItem } from './RollingBannerItem';
export function RollingBanner(props: {
  menus: RollBannerItem[];
  useLoop: boolean;
}) {
  const [sliderRef] = useKeenSlider({
    loop: props.useLoop,
    vertical: true,
    slides: {
      perView: 1
    },
    renderMode: 'performance'
  }, [AutoSlidePlugin]);
  return <div ref={sliderRef} className="keen-slider size-full overflow-hidden" data-sentry-component="RollingBanner" data-sentry-source-file="RollingBanner.tsx">
      {props.menus.map((item, index) => <RollingBannerItem key={index} {...item} />)}
    </div>;
}
const AutoSlidePlugin = (slider: KeenSliderInstance) => {
  let timeout: ReturnType<typeof setTimeout>;
  function next() {
    // 추천 데이터가 비어 슬라이드가 0개이거나 아직 측정 전(track.details=null)이면
    // keen-slider 내부가 track.details.abs 접근으로 throw → details 있을 때만 진행
    // (Fixes QUIZ-APP-6T9)
    if (slider.track?.details) slider.next();
    timeout = setTimeout(next, 2000); // 2초마다 슬라이드
  }
  slider.on('created', () => {
    timeout = setTimeout(next, 2000);
  });
  slider.on('destroyed', () => {
    clearTimeout(timeout);
  });
};